/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_StartInputs */



/**
* | output |
* | --- |
* | "Start conversation" |
*
* @param {Practice_Session_Audio_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_start = /** @type {((inputs?: Practice_Session_Audio_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Start gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer la conversation")
	return /** @type {LocalizedString} */ ("Start conversation")
});